import { JsonUrlParam } from '../../Shared/useQueryParams/paramTypes/JsonUrlParam';
import SortingService from '../services/SortingService';
const removeUserFiltersThatDoNotBelongToGroup = (chosenUserFilters, userFiltersForGroup) => {
    if (!chosenUserFilters) {
        return null;
    }
    for (const userFilter of Object.keys(chosenUserFilters)) {
        // Remove _min and _max suffix, compare only by the main filter key
        const userFilterWithoutSuffix = userFilter.replace(/_min|_max/, '');
        if (!userFiltersForGroup.some((filter) => filter.field === userFilterWithoutSuffix)) {
            delete chosenUserFilters[userFilter];
        }
    }
    return chosenUserFilters;
};
const getSorting = (currentFilterGroup, sortingField, sortingDirection) => {
    const sortOptions = currentFilterGroup === 'complex' ? SortingService.getAllForComplexes() : SortingService.getAllForUnits();
    const sorting = sortOptions.find((sortOptions) => sortOptions.field === sortingField && sortOptions.direction === sortingDirection);
    const defaultSorting = currentFilterGroup === 'complex' ? 'fields.name' : 'fields.street';
    return sorting
        ? { field: sorting.field, direction: sorting.direction }
        : sortOptions.find((sortOption) => sortOption.field === defaultSorting);
};
const UnitReducer = {
    initialState: (pluginSettings, searchParams) => {
        var _a, _b;
        const groupFilter = JsonUrlParam.decode(searchParams.get('groupFilter'));
        const view = JsonUrlParam.decode(searchParams.get('view'));
        const sorting = JsonUrlParam.decode(searchParams.get('sorting'));
        return {
            reloadNeeded: false,
            loading: false,
            error: false,
            units: [],
            totalUnits: 0,
            aggregations: {},
            sorting: { direction: (_a = sorting === null || sorting === void 0 ? void 0 : sorting.direction) !== null && _a !== void 0 ? _a : 'asc', field: (_b = sorting === null || sorting === void 0 ? void 0 : sorting.field) !== null && _b !== void 0 ? _b : '' },
            currentView: view !== null && view !== void 0 ? view : 'tiles',
            currentPage: 1,
            filters: pluginSettings.filters,
            chosenUserFilters: null,
            chosenGroupFilters: null,
            currentFilterGroup: (groupFilter === null || groupFilter === void 0 ? void 0 : groupFilter.key) && groupFilter.key in pluginSettings.filters
                ? groupFilter.key
                : Object.keys(pluginSettings.filters)[0],
        };
    },
    reducer: (state, action) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        switch (action.type) {
            case 'setLoading':
                return Object.assign(Object.assign({}, state), { loading: true, reloadNeeded: false });
            case 'setData':
                const aggregations = action.value.aggregations || action.value.facets || null;
                return Object.assign(Object.assign({}, state), { units: action.value.hits.hits, totalUnits: action.value.hits.total.value, aggregations: aggregations, loading: false });
            case 'changePage':
                return Object.assign(Object.assign({}, state), { currentPage: action.value, reloadNeeded: true });
            case 'changeView': {
                const reloadNeeded = !((state.currentView === 'list' && action.value === 'tiles') ||
                    (state.currentView === 'tiles' && action.value === 'list'));
                return Object.assign(Object.assign({}, state), { currentView: action.value, reloadNeeded });
            }
            case 'changeSorting':
                return Object.assign(Object.assign({}, state), { sorting: action.value, reloadNeeded: true });
            case 'changeUserFilter':
                return Object.assign(Object.assign({}, state), { chosenUserFilters: action.value, currentPage: 1, reloadNeeded: true });
            case 'changeGroupFilter':
                return Object.assign(Object.assign({}, state), { chosenGroupFilters: action.value.groupFilter, currentFilterGroup: (_b = (_a = action.value.groupFilter) === null || _a === void 0 ? void 0 : _a.key) !== null && _b !== void 0 ? _b : state.currentFilterGroup, currentPage: (_c = action.value.page) !== null && _c !== void 0 ? _c : 1, chosenUserFilters: removeUserFiltersThatDoNotBelongToGroup(state.chosenUserFilters, (_e = state.filters[(_d = action.value.groupFilter) === null || _d === void 0 ? void 0 : _d.key]) === null || _e === void 0 ? void 0 : _e.userFilters), sorting: getSorting((_g = (_f = action.value.groupFilter) === null || _f === void 0 ? void 0 : _f.key) !== null && _g !== void 0 ? _g : state.currentFilterGroup, state.sorting.field, state.sorting.direction), reloadNeeded: true });
            case 'handleQueryFilters':
                return Object.assign(Object.assign({}, state), { chosenGroupFilters: action.value.groupFilter, currentFilterGroup: (_j = (_h = action.value) === null || _h === void 0 ? void 0 : _h.groupFilter.key) !== null && _j !== void 0 ? _j : state.currentFilterGroup, currentPage: (_k = action.value.page) !== null && _k !== void 0 ? _k : state.currentPage, chosenUserFilters: action.value.userFilter, sorting: getSorting((_m = (_l = action.value) === null || _l === void 0 ? void 0 : _l.groupFilter.key) !== null && _m !== void 0 ? _m : state.currentFilterGroup, state.sorting.field, state.sorting.direction), reloadNeeded: true });
            case 'resetUserFilters':
                return Object.assign(Object.assign({}, state), { chosenUserFilters: {}, reloadNeeded: true });
            case 'setError':
                return Object.assign(Object.assign({}, state), { error: true, loading: false });
            default:
                return state;
        }
    },
};
export default UnitReducer;
